/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.passes.detail.series.controllers', [
  'acme.common.service.passes'
])

.controller('PassesDetailSeriesController', ['$scope', 'PassesService', function($scope, PassesService) {

    $scope.passesDetailSeries = {

      model: {},

      init: function() {
        this.model = PassesService.series.getModel();
        $scope.$on('PassesDetailController::UpdateModel', this.onPassesDetailControllerUpdateModel);
        $scope.$on('PassesDetailController::Save', this.onPassesDetailControllerSave);
        this.onPassesDetailControllerUpdateModel();
      },

      updateRangeDisplayTitle: function(series) {
        var i, ii,
          endRange = '',
          startRange = '';

        for (i = 0, ii = series.segments.length; i < ii; i++) {
          if (this.isValueSegmentType(series.segments[i].type)) {
            startRange += series.segments[i].value;
            endRange += series.segments[i].value;
          }else if (this.isRangeSegmentType(series.segments[i].type)) {
            startRange += series.segments[i].startSequence;
            endRange += series.segments[i].endSequence;
          }
        }

        series.valid = true;

        if ((startRange + "").length < PassesService.getModel().characters) {
          startRange += '...';
        }else if ((startRange + "").length > PassesService.getModel().characters) {
          series.valid = false;
        }

        if ((endRange + "").length < PassesService.getModel().characters) {
          endRange += '...';
        }

        series.rangeDisplayTitleStart = startRange;
        series.rangeDisplayTitleEnd = endRange;
        series.rangeDisplayTitle = series.rangeDisplayTitleStart + ' to ' + series.rangeDisplayTitleEnd;

      },

      findSegmentType: function(type) {
        return PassesService.series.findSegmentType(type);
      },

      getSegmentType: function(type) {
        var found = PassesService.series.findSegmentType(type);

        if (found) {
          return found.segmentType;
        }else{
          return {
            type: '',
            label: '',
            shortLabel: ''
          };
        }
      },

      isValueSegmentType: function(type) {
        return PassesService.series.isValueSegmentType(type);
      },

      isRangeSegmentType: function(type) {
        return PassesService.series.isRangeSegmentType(type);
      },

      checkSeries: function(series) {

        var i, ii,
          characters = 0;

        for (i = 0, ii = series.segments.length; i < ii; i++) {
          characters += series.segments[i].characters;
        }

        series.characters = characters;

        this.updateRangeDisplayTitle(series);

      },

      checkValue: function(series, segment) {
        segment.value += "";
        segment.valid = (segment.value && segment.value.length);
        segment.characters = segment.value.length || 0;
        this.checkSeries(series);
      },

      checkSequence: function(series, segment) {
        var startNumber = parseInt(segment.startSequence, 10),
          endNumber = parseInt(segment.endSequence, 10);

        segment.startSequence += "";
        segment.endSequence += "";

        if (!isNaN(startNumber) && !isNaN(endNumber)) {
          if (segment.type === 'ascendingRange') {
            segment.valid = (endNumber > startNumber);
          }else if (segment.type === 'descendingRange') {
            segment.valid = (endNumber < startNumber);
          }else{
            segment.valid = false;
          }
        }

        segment.characters = Math.max(segment.startSequence.length, segment.endSequence.length) || 0;
        this.checkSeries(series);
      },

      updateSeries: function() {

        var i, ii,
            j, jj;

        if (this.model instanceof Array) {
          for (i = 0, ii = this.model.length; i < ii; i++) {
            for (j = 0, jj = this.model[i].segments.length; j < jj; j++) {
              if (this.isValueSegmentType(this.model[i].segments[j].type)) {
                this.checkValue(this.model[i], this.model[i].segments[j]);
              } else if (this.isRangeSegmentType(this.model[i].segments[j].type)) {
                this.checkSequence(this.model[i], this.model[i].segments[j]);
                this.model[i].segments[j].startSequence = PassesService.series.addLeadingZeros(this.model[i].segments[j].startSequence, this.model[i].segments[j].characters);
              }
            }
            this.updateRangeDisplayTitle(this.model[i]);
          }
        }

      },

      success: {
        init: function(response) {}
      },

      error: {
        init: function(response) {}
      },

      onPassesDetailControllerUpdateModel: function(e, data) {
        var self = $scope.passesDetailSeries;

        self.model = PassesService.series.getModel();
        self.updateSeries();
        PassesService.series.setModel(self.model);
      },

      onPassesDetailControllerSave: function(e, data) {
        var self = $scope.passesDetailSeries;

        PassesService.series.setModel(self.model.series);
      }

    };

    $scope.passesDetailSeries.init();

}]);